import React from "react";

export interface InputProps
  extends React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > {}

const Input: React.FC<InputProps> = ({ ...props }) => (
  <input className="fl-p-4 fl-rounded-md" {...props} />
);

export default Input;
